module.exports = __webpack_public_path__ + "img/table43_01.1fa9bc9a.png";